export const LOGIN_REQUIRED_MESSAGE = "로그인 사용자만 가능합니다.";

export default {
  LOGIN_REQUIRED_MESSAGE,
};


